/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccessRequestStatus } from './AccessRequestStatus';
import {
    AccessRequestStatusFromJSON,
    AccessRequestStatusFromJSONTyped,
    AccessRequestStatusToJSON,
    AccessRequestStatusToJSONTyped,
} from './AccessRequestStatus';

/**
 * 
 * @export
 * @interface AccessRequestUpdateStatusResponse
 */
export interface AccessRequestUpdateStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestUpdateStatusResponse
     */
    note?: string | null;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof AccessRequestUpdateStatusResponse
     */
    status?: AccessRequestStatus;
}



/**
 * Check if a given object implements the AccessRequestUpdateStatusResponse interface.
 */
export function instanceOfAccessRequestUpdateStatusResponse(value: object): value is AccessRequestUpdateStatusResponse {
    return true;
}

export function AccessRequestUpdateStatusResponseFromJSON(json: any): AccessRequestUpdateStatusResponse {
    return AccessRequestUpdateStatusResponseFromJSONTyped(json, false);
}

export function AccessRequestUpdateStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestUpdateStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
        'status': json['status'] == null ? undefined : AccessRequestStatusFromJSON(json['status']),
    };
}

export function AccessRequestUpdateStatusResponseToJSON(json: any): AccessRequestUpdateStatusResponse {
    return AccessRequestUpdateStatusResponseToJSONTyped(json, false);
}

export function AccessRequestUpdateStatusResponseToJSONTyped(value?: AccessRequestUpdateStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
        'status': AccessRequestStatusToJSON(value['status']),
    };
}

